import { Phone, Clock, MapPin, Instagram, Facebook, Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border/60 bg-white py-14">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
        <div>
          <img src="/assets/priceline-logo-trimmed.png" alt="Priceline Pharmacy" className="h-20 w-auto" />
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
            Priceline Pharmacy Margaret River — caring for our community's health since 2006.
          </p>
        </div>
        <div data-testid="footer-contact">
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            <li>
              <a href="tel:+61897572224" data-testid="footer-phone-link" className="flex items-center gap-2 font-semibold text-brand-pink hover:text-brand-pinkdark">
                <Phone className="h-4 w-4" /> (08) 9757 2224
              </a>
            </li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-brand-green" /> 146 Bussell Hwy, Margaret River WA 6285</li>
            <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-brand-green" /> Mon–Sun, 8am–6pm</li>
          </ul>
          <div className="mt-4 flex gap-3" data-testid="footer-socials">
            <a
              href="https://www.instagram.com/margaret_river_pharmacy"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram — margaret_river_pharmacy"
              className="rounded-full border border-border/60 p-2.5 text-muted-foreground transition-colors duration-200 hover:border-brand-pink hover:text-brand-pink"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61572852914641"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              aria-label="Facebook — Margaret River Pharmacy New Page"
              className="rounded-full border border-border/60 p-2.5 text-muted-foreground transition-colors duration-200 hover:border-brand-pink hover:text-brand-pink"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>
        <div data-testid="footer-links">
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest">Explore</h3>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            <li><a href="#services" data-testid="footer-services-link" className="hover:text-brand-pink">Pharmacy services</a></li>
            <li><a href="#scope" data-testid="footer-scope-link" className="hover:text-brand-pink">Everyday care consults</a></li>
            <li><a href="#book" data-testid="footer-book-link" className="hover:text-brand-pink">Book a service</a></li>
            <li><a href="https://dermagen.net.au" target="_blank" rel="noopener noreferrer" data-testid="footer-dermagen-link" className="hover:text-brand-pink">DermaGen skincare</a></li>
            <li><a href="https://www.priceline.com.au" target="_blank" rel="noopener noreferrer" data-testid="footer-priceline-link" className="hover:text-brand-pink">Priceline Australia</a></li>
            <li>
              <a
                href="https://compound-hub-7.emergent.host/?utm_source=share"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-staff-login-link"
                className="inline-flex items-center gap-2 rounded-full border border-foreground/20 px-4 py-1.5 font-heading text-sm font-semibold text-foreground transition-colors duration-200 hover:border-brand-pink hover:text-brand-pink"
              >
                <Lock className="h-3.5 w-3.5" /> Staff login
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest">Our own brand</h3>
          <img src="/assets/dermagen-logo.webp" alt="DermaGen by Botanical Chemist" className="mt-4 w-44 rounded-lg" />
          <p className="mt-3 text-xs text-muted-foreground">Formulated by our pharmacist, made in Western Australia.</p>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-7xl border-t border-border/60 px-5 pt-6 lg:px-10">
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} Priceline Pharmacy Margaret River. General information only — always speak
          with our pharmacist or your GP about your individual health needs. In an emergency call 000.
        </p>
      </div>
    </footer>
  );
}
